import React from "react";
import { Button } from "./ui/button";
import { Heart, ShieldCheck, CreditCard, ExternalLink } from "lucide-react";

const PAYMENT_LINK_URL = "https://buy.stripe.com/dRmfZh7c1ecd1O99ytgMw00";

const SUGGESTED = [25, 50, 100, 250, 500];

const Donate = () => {
  const openCheckout = () => {
    window.open(PAYMENT_LINK_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="donate" className="relative py-24 lg:py-32 bg-white overflow-hidden">
      <div className="absolute top-0 left-0 right-0 divider-stripe" />
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-[11px] uppercase tracking-[0.24em] text-[#b22234] font-bold mb-4">
            Support the Campaign
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl font-extrabold text-[#0a3161] leading-tight">
            Help Us With Your Donation
          </h2>
          <div className="mt-6 h-1 w-20 bg-[#b22234] rounded-full mx-auto" />

          <p className="mt-8 text-lg text-[#0a3161] font-semibold">
            Every dollar reaches more voters
          </p>
          <p className="mt-3 text-slate-600 text-[17px] leading-relaxed">
            Your donation goes directly toward mailers, yard signs, and door-to-door outreach that
            help us connect with families across the 19th District.
          </p>
        </div>

        <div className="mt-12 bg-slate-50 border border-slate-200 rounded-2xl p-8 md:p-12 shadow-sm">
          <div className="text-center">
            <div className="text-xs uppercase tracking-[0.2em] text-[#b22234] font-bold">
              Make a difference
            </div>
            <p className="mt-3 text-slate-600 text-[15px]">
              Choose any amount that&rsquo;s meaningful to you. You&rsquo;ll enter your donation amount and
              payment details on the next screen.
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
              {SUGGESTED.map((amt) => (
                <button
                  key={amt}
                  type="button"
                  onClick={openCheckout}
                  className="amount-btn px-5 py-2 rounded-full bg-white border border-slate-300 text-[#0a3161] hover:text-white hover:bg-[#0a3161] hover:border-[#0a3161] font-oswald font-semibold text-sm tracking-wide cursor-pointer transition-colors"
                >
                  ${amt}
                </button>
              ))}
              <button
                type="button"
                onClick={openCheckout}
                className="amount-btn px-5 py-2 rounded-full bg-white border border-dashed border-slate-300 text-slate-500 hover:text-white hover:bg-[#0a3161] hover:border-[#0a3161] font-oswald font-medium text-sm tracking-wide cursor-pointer transition-colors"
              >
                or any amount
              </button>
            </div>
          </div>

          <Button
            onClick={openCheckout}
            className="mt-8 w-full bg-[#b22234] hover:bg-[#8f1a29] text-white rounded-full h-14 text-base font-oswald font-semibold uppercase tracking-[0.14em] shadow-md hover:shadow-lg"
          >
            <Heart className="w-5 h-5 mr-2" />
            Donate Now
            <ExternalLink className="w-4 h-4 ml-2 opacity-80" />
          </Button>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-4 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheck className="w-3.5 h-3.5 text-emerald-600" />
              Secure checkout by Stripe
            </span>
            <span className="inline-flex items-center gap-1.5">
              <CreditCard className="w-3.5 h-3.5" />
              Card, Apple Pay, Google Pay, Link
            </span>
          </div>

          <p className="mt-5 text-[11px] text-slate-500 leading-relaxed text-center max-w-2xl mx-auto">
            Contributions are not tax-deductible. Federal law requires us to collect name, address,
            employer and occupation for donors giving $200 or more. Foreign nationals may not contribute.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Donate;
